module.exports = __webpack_public_path__ + "img/tq.cfe29ce7.jpg";